import { CAMPAIGN_COPY_FALLBACK } from '@/constants/gifting';
import type { CampaignCopy } from '@/types/gifting';

/**
 * The server's campaign identity strings, made total. Per-field fallback
 * (`||`, not `??`) so an ABSENT field, a null, or an empty string all fall
 * back to the shipped copy — a half-populated server row must never render
 * a blank headline.
 *
 * Screens with a user pass `authStore.user?.gifting_copy`; the public
 * landing passes `giftingStore.campaignCopy` (from the catalog response);
 * both may be undefined and the result is still complete.
 */
export function campaignCopy(server?: Partial<CampaignCopy> | null): CampaignCopy {
  return {
    name: server?.name || CAMPAIGN_COPY_FALLBACK.name,
    headline: server?.headline || CAMPAIGN_COPY_FALLBACK.headline,
    subhead: server?.subhead || CAMPAIGN_COPY_FALLBACK.subhead,
    cta_label: server?.cta_label || CAMPAIGN_COPY_FALLBACK.cta_label,
    share_text: server?.share_text || CAMPAIGN_COPY_FALLBACK.share_text,
  };
}
